export const eventLinks = [
  {
    to: 'https://mp.weixin.qq.com/s/yADRD6lneMyvGJ-gdVCMaA',
    titleKey: 'event-title-19',
    isNew: true,
  },
  {
    to: 'https://mp.weixin.qq.com/s/4N2yjFGJpLHzgPCDjWZmYA',
    titleKey: 'event-title-20',
    isNew: true,
  },
  {
    to: 'https://mp.weixin.qq.com/s/pbYfDMGfyFBeAmaparnxbQ',
    titleKey: 'event-title-21',
    isNew: true,
  },
  {
    to: 'https://mp.weixin.qq.com/s/ZgSOejRfyPJvIrrG7h6XWw',
    titleKey: 'event-title-22',
    isNew: true,
  },
  {
    to: 'https://mp.weixin.qq.com/s/vSCXgqgBFusRZ2QeA0PoXw',
    titleKey: 'event-title-18',
    isNew: true,
  },
  {
    to: 'https://mp.weixin.qq.com/s/uFNSKDOwX-aCxzZg7w5xfA',
    titleKey: 'event-title-17',
    isNew: true,
  },
  {
    to: 'https://mp.weixin.qq.com/s/UeGc0BigdXQSx26_WsZFMA',
    titleKey: 'event-title-15',
  },
  {
    to: 'https://mp.weixin.qq.com/s/BEY6HTcJF4Dr5DSBPy1NMw',
    titleKey: 'event-title-14',
  },
  {
    to: 'https://mp.weixin.qq.com/s/0y3ccpJJLuqw1V4rJjywfQ?token=325217238',
    titleKey: 'event-title-13',
  },
  {
    to: 'https://mp.weixin.qq.com/s/pE69FKuDhIgOAhgwrWojLA?token=985437952',
    titleKey: 'event-title-9',
  },
  {
    to: 'https://mp.weixin.qq.com/s/6ZudM6KPNnz01ojDi-qq6w?token=985437952',
    titleKey: 'event-title-10',
  },
  {
    to: 'https://mp.weixin.qq.com/s/xpq5ZTMzYsTh6kaNP3lZbA?token=985437952',
    titleKey: 'event-title-11',
  },
  {
    to: 'https://mp.weixin.qq.com/s/Db51aXJLbcvSdB16zZUgQA',
    titleKey: 'event-title-12',
  },
  {
    to: '/hiring',
    label: '\u5317\u7231\u4e2d\u6587\u5b66\u6821\u62db\u8058\u542f\u4e8b\uff082024-2025\u5b66\u5e74\uff09',
    isExternal: false,
  },
  {
    to: 'https://mp.weixin.qq.com/s/JqDq8LeWK_qUTxNWQAi3-A?poc_token=HHeNYGajarWqVKfsFh-ssQq61WoDtUQdxFQDZsL2',
    label: '\u5317\u7231\u4e2d\u6587\u5b66\u68212024-2025\u5b66\u5e74\u5165\u5b66\u62a5\u540d',
  },
  {
    to: 'https://mp.weixin.qq.com/s/aM-SBsqott07-bHDtVmz9w',
    titleKey: 'event-title-8',
  },
  {
    to: 'https://mp.weixin.qq.com/s/RwNdHI29350rKXLVk63fng',
    titleKey: 'event-title-7',
  },
  {
    to: 'https://mp.weixin.qq.com/s?__biz=MzIyMjczNTU0MA==&mid=2247486175&idx=1&sn=8d4e7133ceaecb06ae94e518d1cd72c1&chksm=e829b704df5e3e128ecf51443828608ac8a6c93620cffbe4855aa9e4e624dfff3156699c58b0&token=1193322797&lang=zh_CN#rd',
    titleKey: 'event-title-1',
  },
  {
    to: 'https://mp.weixin.qq.com/s?__biz=MzIyMjczNTU0MA==&mid=2247487497&idx=1&sn=3b5498e90bbeff9988261e83d4f0502b&chksm=e829add2df5e24c4698d5197824708199b3e328ea281ceb7d9ca7b46b91ce0a775a7cb02c223&token=701621739&lang=zh_CN#rd',
    titleKey: 'event-title-2',
  },
  {
    to: 'https://mp.weixin.qq.com/s?__biz=MzIyMjczNTU0MA==&mid=2247487410&idx=1&sn=0fc6b9866ab3b792881e720b80cf13c7&chksm=e829b269df5e3b7f6a48e7afe0fc2415b1e8f8f7b5c4a2f77afc4cba91e20988433c7217554e&token=1193322797&lang=zh_CN#rd',
    titleKey: 'event-title-3',
  },
  {
    to: 'https://mp.weixin.qq.com/s?__biz=MzIyMjczNTU0MA==&mid=2247486381&idx=2&sn=0b81449b8820cb03e53fc1f0857a7522&chksm=e829b676df5e3f60330f9f2c60e4b98b9d44eca9b28b47d81fafd9aee248ff78596274a13d23&token=1193322797&lang=zh_CN#rd',
    titleKey: 'event-title-4',
  },
  {
    to: 'https://mp.weixin.qq.com/s?__biz=MzIyMjczNTU0MA==&mid=2247487565&idx=1&sn=498e4ed9f36525f212f7a8c59e237a48&chksm=e829ad96df5e2480e645834b27861ad7349508a3293fdbe6b4c9e8dc96cfd4e8684a3bb6aa27&token=701621739&lang=zh_CN#rd',
    titleKey: 'event-title-5',
  },
  {
    to: 'https://mp.weixin.qq.com/s?__biz=MzIyMjczNTU0MA==&mid=2247487629&idx=1&sn=3a499ac043c676f14013869b05cc3286&chksm=e829ad56df5e2440fc1a50224fa5164cd87c8815699870636654a62fa0df35ecb9c6638b1f4a&token=701621739&lang=zh_CN#rd',
    titleKey: 'event-title-6',
  },
];
